import { ReactNode, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "@/components/Loading";
import useAuth from "@/hooks/useAuth";
import { ROUTES_PATH } from "@/router";

type AuthenticatedProps = {
  children: ReactNode;
};

export default function Authenticated({ children }: AuthenticatedProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading.Absolute />;
  }
  if (!user) {
    return <Navigate to={ROUTES_PATH.LOGIN} replace />;
  }
  return <Suspense fallback={<Loading.Absolute />}>{children}</Suspense>;
}
